// extracted by mini-css-extract-plugin
export var button = "_ti-1";
export var container = "_ti-0";